import React, { useEffect } from 'react';
import { X } from 'lucide-react';

/**
 * Click-to-zoom luxury product lightbox.
 * Renders full-screen dark overlay with the product image centred + name underneath.
 */
const ImageLightbox = ({ product, onClose }) => {
  useEffect(() => {
    if (!product) return;
    const onKey = (e) => e.key === 'Escape' && onClose();
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [product, onClose]);

  if (!product) return null;

  return (
    <div
      className="lux-lightbox-overlay"
      onClick={onClose}
      data-testid="lightbox-overlay"
      role="dialog"
      aria-modal="true"
    >
      <button
        type="button"
        onClick={onClose}
        className="lux-lightbox-close"
        data-testid="lightbox-close"
        aria-label="Close"
      >
        <X size={28} />
      </button>
      <div className="lux-lightbox-stage" onClick={(e) => e.stopPropagation()}>
        <img
          src={product.image}
          alt={product.name}
          className="lux-lightbox-image"
          data-testid="lightbox-image"
        />
        <div className="lux-lightbox-caption">{product.name}</div>
      </div>
    </div>
  );
};

export default ImageLightbox;
